import { Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { UserAvatarComponent } from '../../user-avatar/user-avatar.component';

import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { UserTypes } from '../../../types/user.model';
import { AuthService } from 'core/services/auth.service';

export interface Avatar {
  id: number;
  name: string;
  image: string;
  level: number;
}

export interface UserType {
  id: number;
  name: string;
  code: string;
}

export interface Ganamigo {
  id: number;
  full_name: string;
  first_name: string;
  last_name: string;
  status: string;
  avatar?: Avatar;
  level: number;
  phone: string;
  reward_based: boolean;
  profile_color?: string;
  user_type?: UserType;
}

@Component({
  selector: 'my-ganamigos-network-list',
  standalone: true,
  imports: [NzTooltipModule, NzIconModule, TranslateModule, NzButtonModule, UserAvatarComponent],
  templateUrl: './my-ganamigos-network-list.component.html',
  styleUrl: './my-ganamigos-network-list.component.scss'
})
export class MyGanamigosNetworkListComponent {
  public environment: typeof environment = environment;
  @Input() public ganamigosNetwork: Ganamigo[];
  @Output() public ganamigosClick: EventEmitter<any>;
  @Output() public sendMessage: EventEmitter<any>;
  @Output() public shareGanas: EventEmitter<any>;

  constructor(private _authService: AuthService) {
    this.ganamigosClick = new EventEmitter<number>();
    this.sendMessage = new EventEmitter<any>();
    this.shareGanas = new EventEmitter<any>();
  }

  public onGanamigosClick(ganarbol: any): void {
    this.ganamigosClick.emit(ganarbol);
  }

  public getInitials(ganarbol: any): string {
    const { first_name, last_name } = ganarbol;
    return [first_name, last_name].map((name: string) => name?.charAt(0)?.toUpperCase() || '').join('');
  }

  public getAvatarUrl(ganarbol: any): string {
    if (!ganarbol?.avatar?.image) {
      return '';
    }
    return environment.avatarsUrl + 'Property_1=' + ganarbol?.avatar?.image;
  }

  public onSendMessageClick(event: MouseEvent, ganamigo: any): void {
    event.preventDefault();
    event.stopPropagation();
    this.sendMessage.emit(ganamigo);
  }

  public onShareGanasClick(event: MouseEvent, ganamigo: any): void {
    event.preventDefault();
    event.stopPropagation();
    this.shareGanas.emit(ganamigo);
  }

  public shouldShowShareGanas(ganamigo: Ganamigo): boolean {
    const currentUserIsRewardBased = this._authService.currentUser.isRewardBased;
    if (!currentUserIsRewardBased) {
      return false;
    }
    const specialTypes: UserTypes[] = [UserTypes.PR, UserTypes.CO, UserTypes.RE, UserTypes.PA];
    const isSpecialUserType: boolean = specialTypes.includes(ganamigo?.user_type?.code as UserTypes);
    if (ganamigo.reward_based === false) {
      return false;
    }
    if (isSpecialUserType) {
      return ganamigo.reward_based === true;
    } else {
      return true;
    }
  }
}
